"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isomorphic_ws_1 = __importDefault(require("isomorphic-ws"));
const Subject_1 = require("../utils/Subject");
const WS = isomorphic_ws_1.default;
function basicSocket(url, options) {
    const socket = new WS(url, options);
    socket.binaryType = 'arraybuffer';
    const waitingForConnected = [];
    socket.addEventListener('open', () => {
        var _a;
        while (waitingForConnected.length) {
            (_a = waitingForConnected.shift()) === null || _a === void 0 ? void 0 : _a.resolve();
        }
    });
    socket.addEventListener('close', () => {
        var _a;
        while (waitingForConnected.length) {
            (_a = waitingForConnected.shift()) === null || _a === void 0 ? void 0 : _a.reject(new Error('The WebSocket closed before it connected.'));
        }
    });
    socket.addEventListener('error', error => {
        var _a;
        while (waitingForConnected.length) {
            (_a = waitingForConnected.shift()) === null || _a === void 0 ? void 0 : _a.reject(error);
        }
    });
    return {
        id: `${Math.random()}`,
        url,
        addEventListener: socket.addEventListener.bind(socket),
        removeEventListener: socket.removeEventListener.bind(socket),
        send: socket.send.bind(socket),
        close: socket.close.bind(socket),
        open() {
            if (socket.readyState >= socket.OPEN) {
                return Promise.resolve();
            }
            else
                return new Promise((resolve, reject) => waitingForConnected.push({ resolve, reject }));
        },
        watch() {
            const subject = new Subject_1.Subject({ maxQueueLength: 100 });
            const onMessage = (message) => subject.onNext(message.data);
            socket.addEventListener('message', onMessage);
            subject.finally(() => {
                socket.removeEventListener('message', onMessage);
            });
            const onError = (message) => subject.onError(message);
            socket.addEventListener('error', onError);
            subject.finally(() => {
                socket.removeEventListener('error', onError);
            });
            const onClose = (e) => {
                if (process.env.NODE_ENV === 'development') {
                    console.error(e);
                }
                subject.onError(new Error('The websocket was closed.'));
            };
            socket.addEventListener('close', onClose);
            subject.finally(() => {
                socket.removeEventListener('close', onClose);
            });
            return subject.iterator;
        },
    };
}
exports.default = basicSocket;
//# sourceMappingURL=basicSocket.js.map